import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';
import './Auth.css';

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [form, setForm] = useState({
    firstName: '', lastName: '', email: '', password: '', confirmPassword: '',
    role: searchParams.get('role') === 'seller' ? 'SELLER' : 'BUYER',
    businessName: '', businessDescription: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    if (form.password !== form.confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    if (form.password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    setLoading(true);
    try {
      const { confirmPassword, ...submitData } = form;
      const user = await register(submitData);
      toast.success(`Welcome to African Marketplace, ${user.firstName}!`);
      if (user.role === 'SELLER') navigate('/dashboard/seller');
      else navigate('/');
    } catch (err) {
      setError(err.response?.data?.error?.message || 'Registration failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card auth-card-wide">
        <div className="auth-logo">
          <span>🌍</span>
          <div><span className="logo-african">African</span><span className="logo-marketplace"> Marketplace</span></div>
        </div>

        <h1 className="auth-title">Create your account</h1>
        <p className="auth-subtitle">Join our community of African professionals and customers</p>

        {/* Account Type Toggle */}
        <div className="role-toggle">
          <button
            type="button"
            className={`role-btn ${form.role === 'BUYER' ? 'active' : ''}`}
            onClick={() => setForm(f => ({ ...f, role: 'BUYER' }))}
          >
            👤 I'm a Buyer
            <span>Looking for services</span>
          </button>
          <button
            type="button"
            className={`role-btn ${form.role === 'SELLER' ? 'active' : ''}`}
            onClick={() => setForm(f => ({ ...f, role: 'SELLER' }))}
          >
            🏪 I'm a Seller
            <span>Offering services</span>
          </button>
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="auth-grid">
            <div className="form-group">
              <label className="form-label">First Name</label>
              <input type="text" name="firstName" className="form-input" placeholder="Amina"
                value={form.firstName} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label className="form-label">Last Name</label>
              <input type="text" name="lastName" className="form-input" placeholder="Diallo"
                value={form.lastName} onChange={handleChange} required />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Email Address</label>
            <input type="email" name="email" className="form-input" placeholder="you@example.com"
              value={form.email} onChange={handleChange} required />
          </div>

          <div className="auth-grid">
            <div className="form-group">
              <label className="form-label">Password</label>
              <input type="password" name="password" className="form-input" placeholder="Min 8 characters"
                value={form.password} onChange={handleChange} required minLength={8} />
            </div>
            <div className="form-group">
              <label className="form-label">Confirm Password</label>
              <input type="password" name="confirmPassword" className="form-input" placeholder="Repeat password"
                value={form.confirmPassword} onChange={handleChange} required />
            </div>
          </div>

          {form.role === 'SELLER' && (
            <>
              <div className="seller-fields">
                <h3 className="seller-fields-title">🏪 Business Details</h3>
                <div className="form-group">
                  <label className="form-label">Business Name</label>
                  <input type="text" name="businessName" className="form-input" placeholder="e.g. Amina's Kitchen"
                    value={form.businessName} onChange={handleChange} required />
                </div>
                <div className="form-group">
                  <label className="form-label">Business Description</label>
                  <textarea name="businessDescription" className="form-textarea"
                    placeholder="Tell customers what you offer..."
                    value={form.businessDescription} onChange={handleChange} rows={3} required />
                </div>
              </div>
            </>
          )}

          <button type="submit" className="btn btn-primary btn-block btn-lg" disabled={loading}>
            {loading ? 'Creating account...' : 'Create Account'}
          </button>
        </form>

        <p className="auth-footer">
          Already have an account? <Link to="/login">Sign in here</Link>
        </p>
      </div>
    </div>
  );
}
